import React from 'react';

function Home() {
  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="max-w-4xl w-full text-center">
        <div className="mb-12 animate-fade-in">
          <h1 className="text-6xl font-bold text-gray-900 mb-4 bg-gradient-to-r from-primary-600 to-secondary-600 bg-clip-text text-transparent">
            Innovis VC Arena
          </h1>
          <p className="text-xl text-gray-600 mb-8">An evening to invest in the future</p>
        </div>

        <div className="card text-center animate-slide-up max-w-2xl mx-auto">
          <div className="mb-6">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Welcome to Innovis VC Arena</h2>
            <p className="text-gray-600 mb-6">
              Each participant receives an individual QR code that leads directly to their personal dashboard.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-4 mb-6">
            <a
              href="/setup"
              className="btn-primary inline-block"
            >
              Event Setup
            </a>
            <a
              href="/admin"
              className="btn-secondary inline-block"
            >
              Admin-Dashboard
            </a>
          </div>

          <p className="text-sm text-gray-500 mt-4">
            QR codes can be retrieved in the Setup section after configuration
          </p>
        </div>
      </div>
    </div>
  );
}

export default Home;
